var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loginBackground[data-v-b778dbd8]{height:100vh;width:100vw;background-image:url(" + escape(require("../../images/loginBG.png")) + ");background-size:cover;display:flex}.formLogin[data-v-b778dbd8]{min-height:600px}.loginLogo[data-v-b778dbd8]{margin-bottom:30px}.doLogin[data-v-b778dbd8]{bottom:0 !important;right:0 !important;font-size:19px !important;font-weight:500 !important;text-align:center;color:#fff}h3[data-v-b778dbd8]{font-size:22px;line-height:1.18;text-align:center;margin-bottom:40px;color:#000;font-weight:normal}", ""]);

// exports
